export default "__VITE_ASSET__WOuYh$hZ__"